// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__HQ97U","productName":"Table_productName__3XXXK"};